@if (!loading) {
<div class="box">
  <div class="table-toolbar">
    <mat-form-field class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search subscriptions…" />
    </mat-form-field>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="group_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Group</th>
        <td mat-cell *matCellDef="let element">{{ element.group_name }}</td>
      </ng-container>

      <ng-container matColumnDef="channel_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Channel</th>
        <td mat-cell *matCellDef="let element">{{ element.channel_name }}</td>
      </ng-container>

      <ng-container matColumnDef="Description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let element">{{ element.Description }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button class="action-btn" title="Edit"
                  (click)="openModal(applicationName, element, 'Edit', true); $event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matNoDataRow>
        <td colspan="4">
          <div class="empty-state">
            <mat-icon>subscriptions</mat-icon>
            <p>No subscriptions found</p>
          </div>
        </td>
      </tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
          class="table-row" (click)="openModal(applicationName, row, 'Edit', true)"></tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons aria-label="Select page">
  </mat-paginator>
</div>
}

@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}
